module.exports = __webpack_public_path__ + "img/digital-menuboards.8af5bfec.webp";